// extracted by mini-css-extract-plugin
module.exports = {"container":"_b7a8d75e","title":"_fffb7d59"};